export const showTimeoutDebugging = (() => {
  try {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('enableTimeoutDebugging');
  }
  catch {
    return false;
  }
})();